import Api from '../Api.js';
import BaseView from './_BaseView.js';
import Confirm from '../components/Confirm.js';
import Dropdown from '../components/Dropdown.js';
import Table from '../components/Table.js';
import FileImport from '../components/FileImport.js';
import trans from "../util/trans";

export default class UsersView extends BaseView {
    constructor() {
        super();
        this.formSelector = '#userForm';
        this.formUrl = '/api/users';
        this.formTpl = 'user-form';
        this.formTitle = Lang.userinfo;
        this.modalClasses = 'large-modal';
        this.defaultObject = {
            firstname: '',
            lastname: '',
            email: ''
        };
        this.formCallback = function () {
            this.table.reload();
            if (this.nonadmins) {
                this.nonadmins.reload();
            }
        };
    }

    init() {
        super.init();
        const self = this;
        if ($('#userGroup').length > 0) {
            let url = '/api/users/table';
            const org = $('[data-org]').data('org');

            let columns = [
                {data: 'select', orderable: false},
                {data: 'firstname'},
                {data: 'lastname'},
                {data: 'email'},
                {data: 'created_at'},
                {data: 'lastlogin'},
                {data: 'organization.name', defaultContent: ''},
                {data: 'admin'},
                {data: 'tools', orderable: false},
            ];

            if (org && org.length > 0) {
                url += `?org=${org}`;
                columns = [
                    {data: 'select', orderable: false},
                    {data: 'firstname'},
                    {data: 'lastname'},
                    {data: 'email'},
                    {data: 'created_at'},
                    {data: 'lastlogin'},
                    {data: 'admin'},
                    {data: 'tools', orderable: false},
                ];
            }

            this.table = new Table('users', url, columns);

            if ($('#nonadmins').length > 0) {
                url += '?nonadmin=1';
                this.nonadmins = new Table('nonadmins', url, columns);
            }

            this.menu = new Dropdown('#userPageMenu', {
                onDelete: function (ids) {
                    if (ids.length > 0) {
                        Confirm({
                            ok: Lang.delete,
                            title: Lang.deleting,
                            msg: trans('deletexusers', {x: ids.length}),
                            onConfirm: function () {
                                $.each(ids, function (i, row) {
                                    Api.send(`/api/users/${row}`, {}, 'delete').done(function () {
                                        self.table.reload();
                                    });
                                });
                            }
                        });
                    }
                },
                //holding off this feature now for security risk (Aya 4/16/2019)
                // onExport: function (ids) {
                //     console.log("multi export " + ids);
                //     const host = $('[data-host]').data('host');
                //         window.location = `/api/users/multiexport?host=${host}&ids=${ids}`;
                // }
            });

            const fileImport = new FileImport($('#importUsers'), {
                url: '/api/users/import',
                formTpl: 'import-file-form',
                title: Lang.userfile,
                datalist: self.table,
                type: 'dropdown'
            });
            fileImport.init();
        }
    }

    renderExport(apps) {
        Api.getTpl('user-export-form').done(function (r) {
            const tpl = _.template(r);

            Confirm({
                ok: Lang.export,
                title: Lang.appseltitle,
                msg: tpl({apps: apps}),
                onValidate: function () {
                    return $('#userexportform').isFormValid();
                },
                onConfirm: function () {
                    window.location = `/api/users/export?id=${$('#hostlist').val()}&org=${$('[data-org]').data('org')}`;
                    return false;
                }
            });
        });
    }

    renderTemplate(apps) {
        Api.getTpl('user-export-template').done(function (r) {
            const tpl = _.template(r);

            Confirm({
                ok: Lang.template,
                title: Lang.template,
                msg: tpl({apps: apps}),
                onValidate: function () {
                    return $('#userexportform').isFormValid();
                },
                onConfirm: function () {
                    window.location = '/api/users/template?id=' + $('#hostlist').val();
                    return false;
                }
            });
        });
    }

    // renderForm (user) {
    //     const self = this;
    //     let method, url;
    //     if (!user) {
    //         user = {
    //             firstname: '',
    //             lastname: '',
    //             email: ''
    //         };
    //         method = 'post';
    //         url  = '/api/users';
    //     } else {
    //         method  = 'patch';
    //         url = `/api/users/${user.id}`;
    //     }
    //
    //     Api.getTpl('user-form').done(function (r) {
    //         const tpl = _.template(r);
    //
    //         Confirm({
    //             ok: Lang.save,
    //             title: Lang.userinfo,
    //             classes: 'large-modal',
    //             msg: tpl({ user: user }),
    //             onValidate: function () {
    //                 return UsersView.validate();
    //             },
    //             onConfirm: function () {
    //                 const data = $('#userForm').aeroSerialize();
    //                 const org = $('[data-org]').data('org');
    //                 data.sysadmin = !!(data.sysadmin);
    //                 data.orgadmin = !!(data.orgadmin);
    //                 if (org && org.length > 0) {
    //                     data.organization_id = org;
    //                 }
    //                 Api.send(url, data, method).done(function () {
    //                     self.table.reload();
    //                     if (self.nonadmins) {
    //                         self.nonadmins.reload();
    //                     }
    //                 });
    //             }
    //         });
    //     });
    // }

    getFormData() {
        const data = super.getFormData();
        const org = $('[data-org]').data('org');
        data.sysadmin = !!(data.sysadmin);
        data.orgadmin = !!(data.orgadmin);
        if (org && org.length > 0) {
            data.organization_id = org;
        }
        return data;
    }

    validateForm() {
        return UsersView.validate($(this.formSelector));
    }

    static validate(form) {
        const error = [];
        if (!form) {
            form = $('#userForm');
        }

        let valid = form.isFormValid();
        const password = form.find('input[name="password"]');
        const passwordv = form.find('.passwordv');

        const pwregex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");

        if (password.val() !== "" && !pwregex.test(password.val())) {
            valid = false;
            password.addClass('aero-require-error');
            error.push(Lang.weaksauce);
        }

        if (password.val() !== passwordv.val()) {
            valid = false;
            passwordv.addClass('aero-require-error');
            error.push(Lang.passwordmatch);
        }

        if (!valid) {
            //Already error box?
            if (form.find('.aero-error-box').length === 0) {
                form.prepend('<div class="aero-error-box"><ul></ul></div>');
            }

            for (let i in error) {
                form.find('.aero-error-box ul').append('<li>' + error[i] + '</li>');
            }

            if (form.find('#panel2-1 .aero-require-error').length === 0) {
                form.find('.tabs li:eq(2) a').click();
            }
        }

        return valid;
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const section = $('#userGroup');

        // Add
        $('#userGroup .add').off("click.usersa").on("click.usersa", function () {
            self.renderForm();
            return false;
        });

        // Edit
        section.off("click.userse").on("click.userse", ".edit", function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/users/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });

        $('body').on('change', '#orgadmin', function () {
            if ($(this).prop('checked')) {
                $('.org-select').show().find('select').prop('disabled', false);
            } else {
                $('.org-select').hide().find('select').prop('disabled', true);
            }
        }).change();

        section.on('click.userd', '.delete', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(1)').text();
            Confirm({
                ok: Lang.delete,
                title: name,
                msg: Lang.delsure,
                onConfirm: function () {
                    Api.send(`/api/users/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                        if (self.nonadmins) {
                            self.nonadmins.reload();
                        }
                    });
                }
            });
            return false;
        });

        //export
        section.off('click.export').on('click.export', '.export', function () {
            Api.send('/api/apps', {org: $('[data-org]').data('org')}).done(function (r) {
                self.renderExport(r);
            });
            return false;
        });

        //export template
        section.on('click', '.download-template', function () {
            Api.send('/api/apps', {org: $('[data-org]').data('org')}).done(function (r) {
                self.renderTemplate(r);
            });
            return false;
        });

        //Disable password if email user is selected and vice versa
        section.on('change', '#emailuser', function () {
            const _this = this;
            $('input[type="password"]').each(function () {
                if ($(_this).is(':checked')) {
                    $(this).prop('disabled', true);
                } else {
                    $(this).prop('disabled', false);
                }
            });
        });
    }
}
